import {
  AfterViewInit, ChangeDetectorRef,
  Compiler,
  Component, ComponentFactoryResolver,
  Input, NgModule,
  OnInit, ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {Item} from "../../models/Item";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-after-settings-component',
  templateUrl: './after-settings.component.html',
  styleUrls: ['./after-settings.component.scss']
})
export class AfterSettingsComponent implements OnInit, AfterViewInit {

  @Input() item;
  private temp;

  @ViewChild('dynamicComponent', {static: true, read: ViewContainerRef}) vc: ViewContainerRef;

  constructor(private cdr: ChangeDetectorRef, private resolver: ComponentFactoryResolver) {}

  ngOnInit() {
    let str = '';
    str += this.item.registeredPlugins.map(plugin => {

    if (plugin.getAfterSetComponent){
      return plugin.getAfterSetComponent()
    }
    return null;
    });
    str = str.replace(/,/g, '');
    this.temp = str;
  }

  createComponent(component, item){
    this.vc.clear();
    const factory = this.resolver.resolveComponentFactory(component);
    const componentRef = this.vc.createComponent(factory);
    // @ts-ignore
    componentRef.instance.item = item;
  }

  ngAfterViewInit(): void {
    let self = this;
    const template = this.temp;

    let componentsToAdd = Item.plugins.reduce((acc, plugin) => acc.concat(plugin.getUsedComponents()), []);

    componentsToAdd.forEach((component)=>{
      this.createComponent(component, self.item);
    });
    this.cdr.detectChanges();


    // this.createComponent()
    // let componentsToAdd = componentsToClone.map((component) => class extends component{});

    // const tmpCmp = (() => {
    //   @Component({template: template})
    //   class Class { @Input() item = {}; }
    //   return Class;
    // })();
    //
    // componentsToAdd.push(tmpCmp);

    // const tmpModule =  NgModule({declarations: componentsToAdd, imports: [CommonModule]})(class {});
    // let self = this;
    // this._compiler.compileModuleAndAllComponentsAsync(tmpModule)
    //   .then((factories) => {
    //     const f = factories.componentFactories[0];
    //     const cmpRef = this.vc.createComponent(f);
    //     cmpRef.instance.item = self.item;
    //   })
  }

}
